import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getFollower = async (id: string) => {
  const { data: userData } = await supabase.auth.getSession()
  if (!userData?.session?.user?.id) {
    return null
  }

  const { data: following, error: followingError } = await supabase
    .from('following_users')
    .select('*')
    .eq('user_id', userData?.session?.user?.id)

  if (followingError) {
    throw new Error(followingError.message)
  }

  const followingIds = following?.map((f) => f.follow_user_id) || []

  return followingIds.includes(id)
}

export default function useUserIsFollowedByMe(id: string) {
  return useQuery({
    queryKey: ['useUserIsFollowedByMe', id],
    queryFn: () => getFollower(id),
    enabled: Boolean(id),
    staleTime: 60000,
  })
}
